import { combineReducers } from 'redux';
import App from '@app/redux/app/reducer';
import Auth from '@app/redux/auth/reducer';
import Profile from '@app/redux/profile/reducer';

export default combineReducers({
  Auth,
  App,
  Profile,
});
